import _ from 'lodash'
import { apiRequest } from "../action/api.action"
import {
  FETCH_MAP_DATA,
  FETCH_SHIPYARDS_DATA,
  FETCH_SHIPYARDS_DATA_SUCCESS,
  FETCH_SHIPYARDS_DATA_FAILURE,
  UPDATE_MAP_PROPERTY,
  FETCH_SHIPYARDS_GEO_DATA,
  FETCH_SHIPYARDS_GEO_DATA_SUCCESS,
  FETCH_SHIPYARDS_GEO_DATA_FAILURE,
  FETCH_ANCHORAGE_GEO_DATA_FAILURE,
  FETCH_ANCHORAGE_GEO_DATA_SUCCESS,
  FETCH_ANCHORAGE_GEO_DATA,
  GET_ROUTE,
  GET_HEATMAP,
  FETCH_VESSELS_IN_ANCHORAGE_SUCCESS,
  FETCH_VESSELS_IN_ANCHORAGE,
  FETCH_VESSELS_IN_ANCHORAGE_FAILURE,
  FETCH_ALL_ANCHORAGE_GEO_DATA,
  FETCH_ALL__ANCHORAGE_GEO_DATA_SUCCESS,
  FETCH_ALL__ANCHORAGE_GEO_DATA_FAILURE,
  FETCH_SHIPYARDS_WATCHLIST_DATA_SUCCESS,
  FETCH_SHIPYARDS_WATCHLIST_DATA_FAILURE,
  FETCH_ALL_SHIPYARDS_DATA_SUCCESS, FETCH_ALL_SHIPYARDS_DATA_FAILURE,
  FETCH_VESSEL_DATA_SUCCESS, FETCH_VESSEL_DATA_FAILURE, FETCH_MAP_DATA_SUCCESS, FETCH_MAP_DATA_FAILURE
} from '../action/map-data.action';
import { FETCH_VESSSEL_ROUTE_SUCCESS, FETCH_VESSSEL_ROUTE_FAILURE, FETCH_VESSSEL_TRACKING_SUCCESS, FETCH_VESSSEL_TRACKING_FAILURE, FETCH_MASTER_DATA_SUCCESS, FETCH_MASTER_DATA_FAILURE, FETCH_VESSEL_VISITS_DATA_SUCCESS, FETCH_SHIPYARD_VISITS_DATA_SUCCESS, FETCH_VISITS_DATA_FAILURE } from '../action/vessels.action';

import { FETCH_PORT_SERVICES_BY_COMPANY_ID, FETCH_PORT_SERVICES_BY_COMPANY_ID_SUCCESS, FETCH_PORT_SERVICES_BY_COMPANY_ID_FAILURE } from '../action/services.action'

export const mapDataFlow = ({ dispatch }) => next => action => {
  next(action)
  if (action.type === FETCH_MAP_DATA ) {
    const boundingBox = action.payload.boundingBox;
    let keyword = action.payload.filter.keyword ? action.payload.filter.keyword : ""

    if (!keyword) {
      return;
    }

    let url = `/api/v1/equipments/vessels-in-bounding-box?keyword=${keyword}&left=${boundingBox.getWest()}&right=${boundingBox.getEast()}&top=${boundingBox.getNorth()}&bottom=${boundingBox.getSouth()}`;

    dispatch(apiRequest('GET', url, null, FETCH_MAP_DATA_SUCCESS, FETCH_MAP_DATA_FAILURE));

  }  else if (action.type ===  FETCH_SHIPYARDS_DATA ) {
    let URL = `/api/v1/business-generator/shipyards-in-bounding-box/company?companyId=${action.payload}`;
    dispatch(apiRequest('GET', URL, null, FETCH_SHIPYARDS_DATA_SUCCESS, FETCH_SHIPYARDS_DATA_FAILURE));

    URL = `/api/v1/business-generator/shipyards-in-bounding-box/myShipyardWatchlist`;
    dispatch(apiRequest('GET', URL, null, FETCH_SHIPYARDS_WATCHLIST_DATA_SUCCESS, FETCH_SHIPYARDS_WATCHLIST_DATA_FAILURE));
  }
  else if(action.type ===GET_ROUTE){
    let URL = `/api/v1/vessels/${action.payload.imo}/route-to-dest`
    dispatch(apiRequest('GET', URL, null, FETCH_VESSSEL_ROUTE_SUCCESS, FETCH_VESSSEL_ROUTE_FAILURE));
  }
  else if(action.type ===GET_HEATMAP){
    if (!action.payload.imo) {
      return;
    }
    let months = action.payload.filter.heatmapMonths
    URL = `/api/v1/vessels/${action.payload.imo}/tracking?months=${months}`
    dispatch(apiRequest('GET', URL, null, FETCH_VESSSEL_TRACKING_SUCCESS, FETCH_VESSSEL_TRACKING_FAILURE));
  }
  else if (action.type ===  UPDATE_MAP_PROPERTY) {
    if (action.payload.currentFeature && action.payload.currentFeature.properties.type === 'vessel' && action.payload.currentFeature.properties.imo) {
      if (isNaN(action.payload.currentFeature.properties.imo)){
        return;
      }
      URL = `/api/v1/vessel/details/${action.payload.currentFeature.properties.imo}`
      dispatch(apiRequest('GET', URL, null, FETCH_MASTER_DATA_SUCCESS, FETCH_MASTER_DATA_FAILURE));

      URL = `/api/v1/vessel-visits/${action.payload.currentFeature.properties.imo}`
      dispatch(apiRequest('GET', URL, null, FETCH_VESSEL_VISITS_DATA_SUCCESS, FETCH_VISITS_DATA_FAILURE));
    } else if (action.payload.currentFeature && action.payload.currentFeature.properties.type === 'shipyard') {
      if (isNaN(action.payload.currentFeature.properties.id)){
        return;
      }
      URL = `/api/v1/shipyards/${action.payload.currentFeature.properties.id}`
      dispatch(apiRequest('GET', URL, null, FETCH_MASTER_DATA_SUCCESS, FETCH_MASTER_DATA_FAILURE));

      URL = `/api/v1/repairs/historic/${action.payload.currentFeature.properties.id}`
      dispatch(apiRequest('GET', URL, null, FETCH_SHIPYARD_VISITS_DATA_SUCCESS, FETCH_VISITS_DATA_FAILURE));
    } else if (action.payload.currentFeature && action.payload.currentFeature.properties.type === 'underwater') {
      if (isNaN(action.payload.currentFeature.properties.id)){
        return;
      }
      URL = `/api/v3/service-supplier/${action.payload.currentFeature.properties.id}/port/${action.payload.currentFeature.properties.port_id}`
      dispatch(apiRequest('GET', URL, null, FETCH_MASTER_DATA_SUCCESS, FETCH_MASTER_DATA_FAILURE));
    }
  }
  if (action.type === FETCH_SHIPYARDS_GEO_DATA){
    let URL = `/api/v1/shipyards/geoData?shipyards=${action.ids}`
    dispatch(apiRequest('GET', URL, null, FETCH_SHIPYARDS_GEO_DATA_SUCCESS, FETCH_SHIPYARDS_GEO_DATA_FAILURE));
  }
  if (action.type === FETCH_ANCHORAGE_GEO_DATA){
    const boundingBox = action.payload.boundingBox;
    let URL = `/api/v1/business-generator/anchorage?anchorageId=${action.payload.anchorageId}&left=${boundingBox.getWest()}&right=${boundingBox.getEast()}&top=${boundingBox.getNorth()}&bottom=${boundingBox.getSouth()}`
    dispatch(apiRequest('GET', URL, null, FETCH_ANCHORAGE_GEO_DATA_SUCCESS, FETCH_ANCHORAGE_GEO_DATA_FAILURE));
  }
  if (action.type === FETCH_ALL_ANCHORAGE_GEO_DATA){
    let URL = `/api/v1/business-generator/all-anchorage`
    dispatch(apiRequest('GET', URL, null, FETCH_ALL__ANCHORAGE_GEO_DATA_SUCCESS, FETCH_ALL__ANCHORAGE_GEO_DATA_FAILURE));
  }
  if (action.type === FETCH_VESSELS_IN_ANCHORAGE){
    let URL = `/api/v1/business-generator/vesselsInAnchorage?anchorageIds=${action.payload.anchorageIds}`
    dispatch(apiRequest('GET', URL, null, FETCH_VESSELS_IN_ANCHORAGE_SUCCESS, FETCH_VESSELS_IN_ANCHORAGE_FAILURE));
  }

  if (action.type === FETCH_PORT_SERVICES_BY_COMPANY_ID) {
    const boundingBox = action.payload.boundingBox;
    let url = `/api/v1/business-generator/port-services-by-company?companyId=${action.payload.companyId}&left=${boundingBox.getWest()}&right=${boundingBox.getEast()}&top=${boundingBox.getNorth()}&bottom=${boundingBox.getSouth()}`
    dispatch(apiRequest('GET', url, null, FETCH_PORT_SERVICES_BY_COMPANY_ID_SUCCESS, FETCH_PORT_SERVICES_BY_COMPANY_ID_FAILURE));
  }

};

export const mapDataMdl = [mapDataFlow];